import { IVehicle } from './vehicle.model';

/**
 * The canonical format of a vehicle plate number: uppercase ASCII letters and digits. Any other
 * character (separators, spaces, accents, ...) is removed. The backend may return or receive
 * plates that were registered without this format; normalize them before comparing or sending.
 */
export function normalizePlateNumber(plateNumber: string): string {
  if (!plateNumber) return '';
  return plateNumber.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

/**
 * Different vehicles in the backend may be the same real vehicle because plate numbers were not
 * normalized at registration. After normalizing them, only the last vehicle of each plate is
 * kept (it is the recent one when they are sorted by plate).
 */
export function dedupeVehiclesByPlateNumber(vehicles: IVehicle[]): IVehicle[] {
  const vehiclesByPlate = new Map<string, IVehicle>();
  for (const vehicle of vehicles) {
    vehiclesByPlate.set(normalizePlateNumber(vehicle.plateNumber), vehicle);
  }
  return Array.from(vehiclesByPlate.values());
}
